import { X, Calendar, Shield, Lock } from "lucide-react";
import { getInitials, getAvatarColor } from "@/mock/data";
import "@/components/ui/Modal.css";

interface UserProfileModalProps {
  userId: string;
  displayName: string;
  username: string;
  createdAt?: string;
  isAdmin?: boolean;
  onClose: () => void;
}

export function UserProfileModal({
  userId,
  displayName,
  username,
  createdAt,
  isAdmin,
  onClose,
}: UserProfileModalProps) {
  const joined = createdAt
    ? new Date(createdAt).toLocaleDateString("en-US", { month: "long", year: "numeric" })
    : "unknown";

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal modal--card"
        onClick={(e) => e.stopPropagation()}
        style={{ padding: 0 }}
      >
        <div className="profile-modal__banner">
          <div
            className="profile-modal__avatar"
            style={{ background: getAvatarColor(userId) }}
          >
            {getInitials(displayName)}
          </div>
          <button className="modal__close" onClick={onClose} style={{ position: "absolute", top: 8, right: 8 }}>
            <X size={16} />
          </button>
        </div>

        <div className="profile-modal__info">
          <div className="profile-modal__name">{displayName}</div>
          <div className="profile-modal__username">@{username}</div>

          <div className="profile-modal__meta">
            <div className="profile-modal__meta-item">
              <Calendar size={14} />
              <span>joined {joined}</span>
            </div>
            {isAdmin && (
              <div className="profile-modal__meta-item profile-modal__meta-item--admin">
                <Shield size={14} />
                <span>admin</span>
              </div>
            )}
          </div>

          <div className="profile-modal__section">
            <div className="profile-modal__section-title">about</div>
            <div className="profile-modal__about">no bio set yet.</div>
          </div>

          <div className="profile-modal__section">
            <div className="profile-modal__section-title">encryption</div>
            <div className="profile-modal__encryption">
              <Lock size={14} />
              <span>e2e keys active. verified.</span>
            </div>
          </div>
        </div>

        <div className="modal__footer" style={{ justifyContent: "center" }}>
          <button className="settings-panel__outline-btn" onClick={onClose}>
            close
          </button>
        </div>
      </div>
    </div>
  );
}
